import { sGisMouseMoveEvent } from "@evergis/sgis/es/commonEvents";
import { PointControl } from "@evergis/sgis/es/controls/PointControl";
import { LabelFeature } from "@evergis/sgis/es/features/Label";
import { DomPainter } from "@evergis/sgis/es/painters/DomPainter/DomPainter";
import { Map as SMap } from "@evergis/sgis/es/Map";
import { ControlWithSymbolParams } from "@evergis/sgis/es/controls/Control";

import { ServerSnappingController } from "../ServerSnappingController";
import { ServerSnappingProvider } from "../ServerSnappingProvider";

import { tooltipSymbol } from "../TooltipSymbol";

import { DEFAULT_LABEL_POSITION } from "../../utils";

import { i18n } from "../../../i18n";

import { SnappingProviderSettings } from "../../../ducks/snapping/types";

export class BasePointCreator extends PointControl {
  snappingProvider: ServerSnappingProvider;

  private snappingController: ServerSnappingController;

  private painter: DomPainter;

  private tempLabel: LabelFeature;

  private noLabel?: boolean;

  constructor(map: SMap, painter: DomPainter, params: ControlWithSymbolParams & { noLabel?: boolean }) {
    super(map, params);

    this.painter = painter;
    this.noLabel = params.noLabel;

    if (!this.noLabel) {
      this.tempLabel = new LabelFeature(DEFAULT_LABEL_POSITION, {
        crs: this.map.crs,
        symbol: tooltipSymbol,
      });
    }

    if (params?.snappingProvider) {
      this.snappingController = new ServerSnappingController({
        map,
        control: this,
        snappingProvider: this.snappingProvider,
        snappingFeature: this._getSnappingFeature(null),
        tempLabel: this.tempLabel,
      });
    }
  }

  updateSnappingProvider(snappingProviderSettings: Partial<SnappingProviderSettings>) {
    this.snappingController.updateSnappingProvider(snappingProviderSettings);
  }

  protected _handleMouseMove(event: sGisMouseMoveEvent) {
    super._handleMouseMove(event);
    this.drawPointOnMouseMove(event);
  }

  protected _activate() {
    super._activate();

    if (!this.noLabel) {
      this.tempLabel.content = i18n.t("clickToSetPoint", { ns: "layerList" });
      this._tempLayer.add(this.tempLabel);
    }

    this.snappingController && this.snappingController.activate();
    this.setCursor("pointer");
  }

  protected _deactivate() {
    super._deactivate();

    if (!this.noLabel) {
      if (this._tempLayer.has(this.tempLabel)) {
        this._tempLayer.remove(this.tempLabel);
      }

      delete this.tempLabel;
    }

    this.snappingController && this.snappingController.deactivate();
    this.setCursor("default");
  }

  private drawPointOnMouseMove(event: sGisMouseMoveEvent) {
    if (this.tempLabel) {
      this.tempLabel.content = i18n.t("clickToSetPoint", { ns: "layerList" });
      this.tempLabel.position = event.point?.position;
    }
  }

  private setCursor(cursor: "pointer" | "default") {
    const { wrapper } = this.painter;

    if (wrapper && typeof wrapper !== "string") {
      wrapper.style.cursor = cursor;
    }
  }
}
